import { Box } from '@mui/material';
import { memo } from 'react';

import useSellerMarketingInfo from 'pages/SellerPage/hooks/useSellerMarketingInfo';
import { Loader } from 'shared/ui/Loader';

import { BrandInfoForm } from './BrandInfoForm';
import { SpecialtiesInfoForm } from './SpecialtiesInfoForm';
import { StatesInfoForm } from './StatesInfoForm';

export const MarketingInfoPage = memo(() => {
  const {
    marketingStates,
    handleUpdateMarketingStates,
    handleUpdateMarketingTags,
    handleUpdateBrand,
    uploadSellerLogo,
    deleteSellerLogo,
    sellerId,
    brandColor,
    brandLogo,
    marketingAllTags,
    marketingSellerTags,
    isLoading,
    isPermittedToModifySeller,
    isUpdatingBrand,
    sellerInfo,
  } = useSellerMarketingInfo();

  return (
    <Box flex="1">
      <Box mt={1} display="flex" height="100%">
        {!isLoading ? (
          <>
            <Box
              p="16px"
              bgcolor="grey.300"
              borderRadius="12px 0 0 12px"
              flexBasis="50%"
              sx={{
                '&:hover .editIconButton': {
                  visibility: isPermittedToModifySeller ? 'visible' : 'hidden',
                },
              }}
            >
              <SpecialtiesInfoForm
                sellerId={sellerId}
                marketingAllTags={marketingAllTags}
                marketingSellerTags={marketingSellerTags}
                handleUpdateMarketingTags={handleUpdateMarketingTags}
              />
            </Box>
            <Box
              p="16px"
              flexBasis="50%"
              borderRadius="0 12px 12px 0"
              border="1px solid"
              borderColor="grey.500"
            >
              <StatesInfoForm
                marketingStates={marketingStates}
                handleUpdateMarketingStates={handleUpdateMarketingStates}
                sellerId={sellerId}
                isPermittedToModifySeller={isPermittedToModifySeller}
              />
              <BrandInfoForm
                seller={sellerInfo}
                brandColor={brandColor}
                brandLogo={brandLogo}
                handleUpdateBrand={handleUpdateBrand}
                uploadSellerLogo={uploadSellerLogo}
                deleteSellerLogo={deleteSellerLogo}
                isUpdatingBrand={isUpdatingBrand}
                isPermittedToModifySeller={isPermittedToModifySeller}
              />
            </Box>
          </>
        ) : (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader size={100} />
          </Box>
        )}
      </Box>
    </Box>
  );
});
